import React, {useContext} from "react";
import {Button} from "@material-ui/core/index";

import Box from "@material-ui/core/Box/index";
import {BrandContext} from "../contexts/BrandContext";
import MspLogo from "../assets/Msplogo";


export default function MspButton(props) {

    const {failCallBack} = props;
    const brand = useContext(BrandContext);

    const loginWithIsams = () =>{
        try {
            const redirectPath = `${window.location.protocol}//${window.location.host}/msp/?sso=[[myschoolportal-sso]]`;
            const target = btoa(redirectPath);

            const ssoRedirect = `${brand.brand.mySchoolPortal}add-sso/?target=${target}`;
            window.open(ssoRedirect, "", "width=600,height=600");
            window.addEventListener('storage', () => {
                const auth = localStorage.getItem('redux-authDal');
                const mspFail = localStorage.getItem('mspFail');
                if(auth){
                    const authObject = JSON.parse(auth)
                    if(authObject.isAuthenticated === 'true'){
                        window.location.reload();
                    }
                }
                if(mspFail){
                    localStorage.removeItem('mspFail');
                    failCallBack(true);
                }
            });
        }
        catch(e){
            console.warn(e);
        }

    };

    return (

            <Box>
                <Button
                    fullWidth
                    size="large"
                    color="inherit"
                    variant="outlined"
                    onClick={loginWithIsams}
                >
                    <MspLogo

                        sx={{
                            width:160,
                            marginTop:1
                        }}
                    />
                </Button>
            </Box>

    );

}